import { connect } from "react-redux";
import SubTotal from "./SubTotal";
import {
  getStoreCode,
  getCountryCode
} from "../../../../state/modules/regionalStore";
import { getTotalPriceText } from "../../../../state/modules/bag";
import { isFeatureActive } from "../../../../state/modules/features";

const mapStateToProps = state => ({
  text: getTotalPriceText(state),
  storeCode: getStoreCode(state),
  countryCode: getCountryCode(state),
  USSalesTaxToggle: isFeatureActive(state, "gbl-us-sales-tax")
});

export default connect(mapStateToProps)(SubTotal);
